const NextI18Next = require('next-i18next').default;
const path = require('path');

const isServer = typeof window === 'undefined';
const localePath = isServer
  ? path.resolve('./public/static/locales')
  : '/static/locales';
const { localeSubpaths } = require('next/config').default().publicRuntimeConfig;

module.exports = new NextI18Next({
  defaultLanguage: 'en',
  otherLanguages: ['fr'],
  shallowRender: true,
  localeSubpaths,
  localePath,
  react: {
    useSuspense: true, // Ensures translations load with suspense
  },
  ns: ['common', 'public', 'admin', 'user'],
  defaultNS: 'common',
});
